var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-taginput',_vm._b({attrs:{"value":_vm.value,"data":_vm.options,"autocomplete":_vm.autocomplete,"type":"is-primary"},on:{"input":function($event){return _vm.$emit('input', $event)},"typing":_vm.onTyping}},'b-taginput',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }